import Vue from 'vue'
import PouchDB from 'pouchdb'
import PouchdbFind from 'pouchdb-find'
import PouchdbLiveFind from 'pouchdb-live-find'
import mixin from './mixin'

PouchDB.plugin(PouchdbFind)
PouchDB.plugin(PouchdbLiveFind)

Vue.prototype.$pouch = new PouchDB(process.env.VUE_APP_NAME, { auto_compaction: true })
Vue.mixin(mixin)
